import { useState } from 'react';

export interface ConsentLabelProps {
  summary: string;
  /** Full consent text (HTML). Replaces the summary when expanded. */
  text: string;
  moreLabel?: string;
  lessLabel?: string;
}

/**
 * Checkbox label for consent copy: shows the short summary, expands to the full text in place
 * (instead of appending it) and inherits the surrounding label's font size.
 */
export const ConsentLabel = ({
  summary,
  text,
  moreLabel = 'Weitere Details',
  lessLabel = 'Weniger anzeigen',
}: ConsentLabelProps) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <span>
      {expanded ? (
        <span className="[&_a]:text-primary [&_a]:underline" dangerouslySetInnerHTML={{ __html: text }} />
      ) : (
        summary
      )}{' '}
      <button
        type="button"
        className="underline"
        aria-expanded={expanded}
        onClick={(event) => {
          // Keep the click from toggling the surrounding checkbox label
          event.preventDefault();
          event.stopPropagation();
          setExpanded((value) => !value);
        }}
      >
        {expanded ? lessLabel : moreLabel}
      </button>
    </span>
  );
};
